import React from "react";

const Entries = ({ category, entries }) => {
  let c = 0;
  if (entries) {
    return (
      entries.length > 0 ? (<div>
        <hr/>
      <div className="text-center sticky-top  bg-white" style={{zIndex:100}}>
      <h4 className="d-inline-block p-1 rounded bg-dark text-white mr-2 mt-3 text-center">{category}</h4>
      <p><span className="text-muted">{entries.length} API's found </span></p>
      </div>
      <div className="row mt-3">
        {entries.map((api) => {
          return (
            <div className="col-md-3 col-xl-4 col-xs-6 mb-5 " key={++c}>
              <div className="mr-1  p-3  h-100 shadow rounded bg-dark text-white text-center">
          <h5 >{api["API"]}  </h5>
                <p>{api.Description}</p>
                <p className="text-muted">
                  Auth Type: {api.Auth.length > 0 ? api.Auth : "No Auth"}{" "}
                </p>
                <a href={api.Link} target="_blank" rel="noopener noreferrer">
                  <button className="btn btn-sm btn-primary">View API</button>
                </a>
                
              </div>
            </div>
          );
        })}
      </div>
    </div>):null
    );
  }
};

export default Entries;
